import styled from 'styled-components'

const Section = styled.div`
  margin: 60px 0 0 0;
`

export default Section
